import React from 'react';
import {Button} from 'semantic-ui-react';

const FileActionButtons = ({file, onEdit, onView, onDelete, onDownload, onCancel}) => {
    const isCalculation = file.fileType === 'Calculation';

    return (
        <div style={{display: 'flex', gap: '12px', alignItems: 'flex-start', flexWrap: 'wrap'}}>
            {(file.status === 'Completed' || file.status === 'Error') && (
                <Button
                    icon
                    size="small"
                    onClick={() => onEdit(file)}
                    title="Редактировать"
                    className="ui button square no-border icon"
                >
                    <i className="fa fa-pencil"></i>
                </Button>
            )}
            {!isCalculation && (file.status === 'ParcelsCreated'
                || file.status === 'Ordered'
                || (file.status === 'Processing' && file.totalRows > 0)) && (
                <Button
                    icon
                    size="small"
                    onClick={() => onView(file)}
                    title="Посмотреть отправления"
                    className="ui button square no-border icon"
                >
                    <i className="fa fa-list"></i>
                </Button>
            )}
            {isCalculation && file.status === 'Processing' && onCancel && (
                <Button
                    icon
                    size="small"
                    onClick={() => onCancel(file)}
                    title="Отменить расчет"
                    className="ui button square no-border icon"
                >
                    <i className="fa fa-times"></i>
                </Button>
            )}
            {file.hasSourceFile && (
                <Button
                    icon
                    size="small"
                    onClick={() => onDownload(file)}
                    title={(isCalculation && file.status === 'Calculated') ? 'Скачать итоговый файл' : 'Скачать исходный файл'}
                    className="ui button square no-border icon"
                >
                    <i className="fa fa-download"></i>
                </Button>
            )}
            {file.canDelete && (
                <Button
                    icon
                    size="small"
                    onClick={() => onDelete(file.id)}
                    title="Удалить"
                    className="ui button square no-border icon"
                >
                    <i className="fa fa-trash"></i>
                </Button>
            )}
        </div>
    );
};

export default FileActionButtons;



// WEBPACK FOOTER //
// ./App/pages/massUpload/components/FileActionButtons.jsx